import HeadCustom from "../../../HeadCustom";
import { useMemo, useState } from "react";
import { Article } from "../../../ui/atoms/Article";
import { Category } from "../../campaign/components/organism/Category";
import { HorizontalScroller } from "../../../ui/organisms/HorizontalScroller";
import PageNotFound from "../../../pages/PageNotFound";
import {useFetchAllNews} from "../hooks/useFetchAllNews";
import { AnimatePresence } from "framer-motion";

const Actus = () => {
    
    const { data, isLoading, error } = useFetchAllNews();
    console.log(data);
    
    const [categorySeleted, setCategorySelected] = useState("Divertissement");

    const categoriesOnly = useMemo(() => {
        if (!data) return [];
        return [...new Set(data.flatMap(item => item.categories).filter(Boolean))];
    }, [data]);

    const filteredData = useMemo(() => {
        if (!data) return [];
        return data.filter(post => post.categories?.includes(categorySeleted));
    }, [data, categorySeleted]);

    if (error) return <PageNotFound />;

    return (
        <AnimatePresence initial={false} mode="wait">
            {!isLoading && (
                <>
                    <HeadCustom headtitle="Lab Mobali - Actus" />

                    <Article className="h-auto flex items-center justify-center">
                        <div className="lg:max-w-2xl fixed top-20 z-10">
                            <Category
                                categories={categoriesOnly}
                                categorySeleted={categorySeleted}
                                setCategorySelected={setCategorySelected}
                            />
                        </div>

                        <HorizontalScroller
                            type="actus"
                            title="Actus"
                            items={filteredData}
                            categorySelected={categorySeleted}
                            categoryField="categories"
                            filterByCategory={false}
                        />
                    </Article>
                </>
            )}
        </AnimatePresence>
    );
};

export default Actus;